import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start/client";

/**
 * Client-side entry point
 * - Hydrates the server-rendered HTML
 * - Router is automatically created by the TanStack Start plugin
 * - CSS is imported in __root.tsx for SSR support
 */
hydrateRoot(document, <StartClient />);
